import React from "react";
import ShopMain from "../../Components/ShopItems/ShopMain";

const Shop = () => {
  return (
    <div>
      <ShopMain />
    </div>
  );
};

export default Shop;
